import { Button, Col, Form, Input, notification, Popconfirm, Row, Select, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { addRecipeTagApi, listOfRecipeTagsApi, updateRecipeTagApi } from "../../../../../config/Api";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE } from "../../../../../config/constant";

export const AddTags = () => {
    const { Option } = Select;
    const [tagCategory, setTagCategory] = useState('')

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [recipeTagData, setRecipeTagData] = useState()
    const [editRecipeTagRecord, setEditRecipeTagRecord] = useState()
    const [loading, setLoading] = useState(false)

    // get the list of all Recipe Tags 
    //==============================
    const getListOfRecipeTags = () => {
        setLoading(true)

        listOfRecipeTagsApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // call when user click on edit
    //==============================
    const editRecipeTag = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'tag_name': data.name })
        form.setFieldsValue({ 'tag_category': data.tagType })
        setEditRecipeTagRecord(data);
    }

    useEffect(() => {
        getListOfRecipeTags()
    }, []);

    // filter data according to user search input 
    //==============================
    useEffect(() => {
        filterRecipeTag(recipeTagData);
    }, [recipeTagData]);

    // filter recipe tags
    //==============================
    const filterRecipeTag = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.name.toUpperCase().indexOf(data.toUpperCase()) !== -1 || element.tagType.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // update status of recipe Tags
    //==============================
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateRecipeTagApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Recipe Tags Update successfully",
                    });
                    getListOfRecipeTags()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };


    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Tag Type',
            dataIndex: 'tagType',
            key: 'tagType',
            render: (text) => <a>{text}</a>,
            filters: [
                { text: "Allergy Tags", value: "Allergy Tags" },
                { text: "Disease Tags", value: "Disease Tags" },
                { text: "Nutrient Tags", value: "Nutrient Tags" },
                { text: "Cuisine Tags", value: "Cuisine Tags" },
                { text: "Type of Diet Tags", value: "Type of Diet Tags" },
                { text: "Recipe by Cooking Method Tags", value: "Recipe by Cooking Method Tags" },
                { text: "Recipe by seasons Tags", value: "Recipe by seasons Tags" },
                { text: "Recipe by difficulty level Tags", value: "Recipe by difficulty level Tags" },
                { text: "Other Tags", value: "Other Tags" },
                { text: "Goal Tags", value: "Goal Tags" },
            ],
            onFilter: (value, record) => record.tagType == value,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editRecipeTag(record) }} className="me-2" />
                    {/* <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}> */}
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            name: 'Capsicum',
            tagType: 'Allergy Tags',
            status: true
        },
        {
            id: '2',
            name: 'Asthama',
            tagType: 'Disease Tags',
            status: false
        },
        {
            id: '3',
            name: 'Back Pain',
            tagType: 'Disease Tags',
            status: true
        },
        {
            id: '4',
            name: 'Hypertension',
            tagType: 'Goal Tags',
            status: true
        },
        {
            id: '5',
            name: 'Autism',
            tagType: 'Goal Tags',
            status: true
        },
    ];

    const [form] = Form.useForm();

    // handle submit
    //==============================
    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "name": values.tag_name,
                "tagType": values.tag_category,
                "status": true
            }
            addRecipeTagApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'tag_name': '' })
                        form.setFieldsValue({ 'tag_category': '' })
                        notification.success({
                            message: "Recipe Tag added successfully",
                        });
                        getListOfRecipeTags()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "name": values.tag_name,
                "tagType": values.tag_category,
                "status": values.status
            }
            updateRecipeTagApi(editRecipeTagRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Recipe Tag Update successfully",
                        });
                        getListOfRecipeTags()
                        form.setFieldsValue({ 'tag_name': '' })
                        form.setFieldsValue({ 'tag_category': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };
    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="AddTags">
            <Row>
                <Col xl={17}>
                    <Form
                        name="AddTagsForm"
                        className="AddTags"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row className="AddTagsForm">
                            <Col xl={8}>
                                <Form.Item
                                    name="tag_category"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select Tag Category!",
                                        },
                                    ]}
                                    initialValue=""
                                >
                                    <Select
                                        // value={regType}
                                        onChange={(e) => setTagCategory(e)}
                                    >
                                        <Option value="" disabled hidden>
                                            Select Tag Category
                                        </Option>
                                        <Option value="Nutrient Tags">Nutrient Tags</Option>
                                        <Option value="Cuisine Tags">Cuisine Tags</Option>
                                        <Option value="Type of Diet Tags">Type of Diet Tags</Option>
                                        <Option value="Recipe by Cooking Method Tags">Recipe by Cooking Method Tags</Option>
                                        <Option value="Recipe by seasons Tags">Recipe by seasons Tags</Option>
                                        <Option value="Recipe by difficulty level Tags">Recipe by difficulty level Tags</Option>
                                        <Option value="Other Tags">Other Tags</Option>
                                        <Option value="Allergy Tags">Allergy Tags</Option>
                                        <Option value="Disease Tags">Disease Tags</Option>
                                        <Option value="Goal Tags">Goal Tags</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xl={8} className="ms-1">
                                <Form.Item
                                    name="tag_name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Tag Name!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter Tag Name" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={7}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2"
                                    icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}>
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>
                    </Form>

                </Col>
                <Col xl={2} className="text-end align-self-center">
                    <h6> Total Tags:  {displayData.length > 0 ? displayData.length : 0} </h6>
                </Col>
                <Col xl={5} className="align-self-center">
                    <Input.Search placeholder="Search Recipe Tag"
                        onChange={(e) => { filterRecipeTag(e.target.value); setRecipeTagData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        dataSource={displayData}
                        // pagination={false}
                        rowKey="id"
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div>
    )
}
